import React, { useEffect, useRef, useState } from 'react';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import { useIsDesktop } from '../../Utils/productPageUtils';
import GlobalStyle from '../../styles/globalStylesV2';
import NewHeader from '../HomePage/NewHeader';
import { MainComponentLayout } from './styled';
import OfferStripHeader from '../ArticlePage/OfferStripHeader';

function PageLayout(props) {
  const {
    categoryNavBarData,
    footerObject,
    location,
    showHeader,
    stickyOnly,
    paddingTop,
    paddingTopDesktop,
  } = props;
  const [addedToCart, setAddedToCart] = useState(false);
  const headerHidden = useRef(true);
  const isDesktop = useIsDesktop();
  if (showHeader == '0px' || isDesktop) headerHidden.current = false;
  useEffect(() => {
    setAddedToCart(false);
  }, [addedToCart]);
  return (
    <>
      <NewHeader
        showOldSubHeader={true}
        categoryData={categoryNavBarData}
        addedToCart={addedToCart}
        showCart={true}
        showTrackOrder={true}
        setAddedToCart={setAddedToCart}
        hideCompleteHeader={headerHidden.current}
        showHeader={showHeader}
        location={location || 'other'}
      />
      <OfferStripHeader
        stickyOnly={stickyOnly}
        showHeader={showHeader}
        pdp={true}
        sticky={true}
      />
      <GlobalStyle />
      <MainComponentLayout
        // noPaddingTop={noPaddingTop}
        paddingTop={paddingTop}
        location={location}
        showHeader={showHeader}
        paddingTopDesktop={paddingTopDesktop}
      >
        {props.children}
      </MainComponentLayout>

      <NewFooter showHeader={showHeader} {...footerObject} />
    </>
  );
}

export default PageLayout;
